import styled, { css } from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledCard = styled.div<{
    $smallCard: boolean;
    $notClickable: boolean;
    $noOwner: boolean;
    $smallMinHeight: boolean;
    $hasBrokerLogo: boolean;
}>`
    position: relative;
    width: 100%;
    min-height: 140px;
    margin-bottom: 16px;
    cursor: pointer;
    background-color: var(--color-white);
    border-radius: var(--radius-10);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);

    &:focus {
        background-color: var(--color-grey-400);
    }

    &:last-child {
        margin-bottom: 0;
    }

    @media ${breakpoints.xs} {
        &:last-child {
            margin-bottom: 16px;
        }
    }
    @media ${breakpoints.sm} {
        width: 100%;
    }
    @media ${breakpoints.xs} {
        height: auto;
        min-height: 150px;
        margin-bottom: 2rem;
    }

    ${(props) =>
        props.$notClickable &&
        css`
            cursor: auto;
            box-shadow: none;
        `}
    ${(props) =>
        props.$smallMinHeight &&
        css`
            min-height: 90px;
        `}
    .chip {
        padding: 2px 10px;
        font-size: var(--size-12);
        color: var(--color-tertiary-fg);
        background: var(--color-tertiary);
        border-radius: var(--radius-20);
    }

    .date {
        display: flex;
        align-items: center;
        float: right;
        width: fit-content;

        ${(props) =>
            props.$smallCard &&
            css`
                padding-left: 0;
            `}
        .beforeText {
            margin-right: 10px;
            font-size: var(--size-14);
            color: var(--color-grey-800);
        }

        span {
            margin: 0;
            font-size: var(--size-14);
            line-height: 19px;
            color: var(--color-grey-900);
        }
    }

    .companyImage {
        display: flex;
        flex: 0 0 50px;
        align-items: center;
        width: 50px;
        height: 50px;
        margin-right: 35px;

        img {
            width: 100%;
        }

        @media ${breakpoints.sm} {
            float: ${(props) => (props.$noOwner ? "initial" : "left")};
            width: 42px;
            min-width: 42px;
            height: 42px;
            margin-right: 10px;
            img {
                width: 100%;
            }
        }

        ${(props) =>
            props.$smallCard &&
            `
            float: ${props.$noOwner ? "initial" : "left"};
            width: 42px;
            min-width: 42px;
            height: 42px;
            margin-right: 10px;
            margin-left: 16px;
            @media ${breakpoints.sm} {
                margin-left:0;
            }

            img {
                width: 100%;
            }
            `}

        ${(props) =>
            props.$noOwner &&
            css`
                margin-bottom: 10px;
            `}
    }

    .topBar {
        box-sizing: border-box;
        display: flex;
        align-items: flex-end;
        justify-content: ${(props) => (props.$noOwner ? "flex-end" : "space-between")};
        width: 100%;
        padding-right: 15px;

        ${(props) =>
            props.$noOwner &&
            css`
                position: absolute;
                top: 0;
                right: 0;
            `}
        .owner {
            align-self: self-start;
            box-sizing: border-box;
            height: 4rem;
            display: flex;
            align-items: center;
            width: 40%;
            padding: 5px 15px;
            background-color: var(--color-primary);
            border-top-left-radius: 10px;
            border-bottom-right-radius: 10px;

            &.smallLabel {
                width: 50%;
            }

            .ownerLabel {
                margin-right: 10px;
                font-size: var(--size-12);
                font-weight: var(--weight-600);
                line-height: 16px;
                color: var(--color-primary-fg);
                text-transform: uppercase;
            }

            .ownerName {
                overflow: hidden;
                font-size: var(--size-14);
                line-height: 19px;
                color: var(--color-primary-fg);
                text-overflow: ellipsis;
                text-transform: none;
                white-space: nowrap;
            }
        }

        .topBarRight {
            margin-top: 20px;
            max-width: 50%;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            text-align: right;

            .status {
                white-space: normal;
                text-align-last: right;

                ${(props) =>
                    props.$smallCard &&
                    css`
                        margin-left: 5px;
                    `}
            }
        }
    }

    .description {
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;

        div {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .categoryIcon {
        position: absolute;
        right: 0;
        bottom: 0;
        max-height: 80px;
    }

    .contentWrapper {
        box-sizing: border-box;
        padding: 20px 10px 10px 15px;
        width: 100%;

        .bodyWrapper {
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            width: 100%;

            @media ${breakpoints.sm} {
                display: block;
            }

            ${(props) =>
                props.$noOwner &&
                !props.$hasBrokerLogo &&
                css`
                    width: calc(100% - 120px);
                    @include xs {
                        width: calc(100% - 100px);
                    }
                `}

            ${(props) =>
                props.$smallCard &&
                css`
                    display: block;
                `}
        }

        .bodyWrapperWithCategoryIcon {
            width: calc(100% - 45px);
        }

        .bodyWrapperWithCompanyIcon {
            padding-left: 15px;
            @media ${breakpoints.sm} {
                padding-left: 0;
            }
            ${(props) =>
                props.$smallCard &&
                css`
                    padding-left: 0;
                `}
        }
    }

    .body {
        width: 100%;

        .titleLine {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 16px;
            gap: 10px;

            ${(props) =>
                props.$noOwner &&
                !props.$hasBrokerLogo &&
                css`
                    margin-right: 45px;
                `}
            .bodyTitle {
                display: block;
                align-items: center;
                font-size: var(--size-16);
                font-style: normal;
                font-weight: bold;
                line-height: 22px;
                color: var(--color-secondary);
            }

            .bodyReference {
                margin: 0;
                font-size: var(--size-14);
                color: var(--color-grey-800);
            }
        }

        .bodyText {
            padding-right: 65px;
            margin-top: 10px;
            margin-bottom: 14px;
            font-size: var(--size-14);
            font-style: normal;
            font-weight: normal;
            line-height: 19px;
            color: var(--color-grey-900);
            text-align: left;
        }

        .infos {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            width: 100%;
            margin-top: 10px;
        }

        .info-block {
            ${(props) =>
                !props.$smallCard &&
                css`
                    min-width: 185px;
                `}

            margin-right: 10px;
            text-align: start;
        }

        .info-label {
            display: inline-block;
            margin: 0 10px 0 0;
            font-size: var(--size-14);
            font-weight: normal;
            color: var(--color-grey-800);
        }

        .info-value {
            display: inline-block;
            font-size: var(--size-14);
            font-style: normal;
            font-weight: bold;
            line-height: 19px;
            color: var(--color-grey-900);
            @media ${breakpoints.sm} {
                margin-top: 5px;
                text-align: left;
            }
            ${(props) =>
                props.$smallCard &&
                css`
                    margin-top: 5px;
                    text-align: left;
                `}
        }
    }

    .headerActionLink {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
        display: flex;
        align-items: center;
        padding-right: 15px;
        margin-top: 10px;
        font-size: var(--size-14);
        color: var(--color-primary);
        text-decoration: underline;
        cursor: pointer;

        svg {
            margin-right: 6px;
        }

        &.disabled {
            color: var(--color-grey-700);
            cursor: default;

            svg {
                path {
                    fill: var(--color-grey-700) !important;
                }
            }
        }

        @media ${breakpoints.sm} {
            position: static;
            top: auto;
            right: auto;
        }
        ${(props) =>
            props.$smallCard &&
            css`
                position: static;
                top: auto;
                right: auto;
            `}
    }
`;
